//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from "@/request/index";
import footerNav from "@/components/footerNav";
import { getUrlparams, countDownTimeFunc, toCopy } from "@/utils/util.js";
import { Dialog, Toast, Notify } from "vant";

export default {
  name: "activitiesSelection",
  components: {
    footerNav
  },
  data() {
    return {
      value: "",
      toCopy,
      sampleSelectNameList: "",
      loading: false,
      finished: false,
      refreshing: false,
      allQualityOrderList: []
    };
  },
  created() {},
  updated() {
    document.scrollingElement.scrollTop = 0;
  },
  mounted() {},
  methods: {
    hasMenu(menu) {
      return (
        this.$store.state.menus[111].requestUrlList.filter(item => {
          return item.id == menu;
        }).length > 0
      );
    },
    view(item, Type) {
      var type = Type;
      if (type == "4") {
        if (
          item.sampleSelectStatus == "1" &&
          this.hasMenu("sampleClothingMobileProductView")
        ) {
          type = 2;
        }
        if (
          item.sampleSelectStatus == "1" &&
          this.hasMenu("sampleClothingMobileView")
        ) {
          type = 1;
        }
        if (item.sampleSelectStatus != "1" && this.hasMenu("sampleClothing")) {
          type = 0;
        }
      }
      if (type == "0") {
        this.$router.push({
          name: "editActivitiesSelection",
          query: {
            row: JSON.stringify(item),
            type: "view"
          }
        });
      } else if (type == "1") {
        this.$router.push({
          name: "viewActivitiesSelection",
          query: {
            row: JSON.stringify(item),
            type: "view"
          }
        });
      } else {
        this.$router.push({
          name: "editActivitiesSelection",
          query: {
            row: JSON.stringify(item),
            type: "view"
          }
        });
      }
    },
    edit(row) {
      this.$router.push({
        name: "editActivitiesSelection",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    submit(item) {
      axiosApi
        .getSampleSelectSubmit({
          sampleSelectIdList: [item.sampleSelectId]
        })
        .then(response => {
          this.allQualityOrderList = [];
          this.onLoad();
          Notify({ type: "success", message: "提交成功" });
        });
    },
    selectSample(item, type) {
      if (type == "1") {
        this.$router.push({
          name: "selectSampleHK",
          query: {
            row: JSON.stringify(item)
          }
        });
      }
      if (type == "2") {
        this.$router.push({
          name: "selectSamplePM",
          query: {
            row: JSON.stringify(item)
          }
        });
      }
    },
    onSearch() {
      this.allQualityOrderList = [];
      this.onLoad();
    },
    onLoad() {
      // getSendOrderList
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      var params = {
        sampleSelectNameList: this.sampleSelectNameList
          ? this.sampleSelectNameList.split(" ")
          : [],
        start: this.allQualityOrderList.length,
        size: 10,
        orderRules: [
          {
            orderKey: "t1.sampleSelectId",
            desc: true
          }
        ]
      };
      axiosApi.getSampleSelectMobileQueryList(params).then(response => {
        if (
          response.content &&
          response.content.list &&
          response.content.list.length > 0
        ) {
          response.content.list.forEach(item => {});
          this.allQualityOrderList = this.allQualityOrderList.concat(
            response.content.list
          );
        }
        this.loading = false;
        this.refreshing = false;
        if (this.allQualityOrderList.length == response.content.total) {
          this.finished = true;
        }
      });
    },
    toAll(sampleSelectId) {
      this.$router.push({
        name: "allQualityDetail",
        query: { sampleSelectId: sampleSelectId }
      });
    },
    clickBtn() {
      Dialog.confirm({
        title: "提示",
        message: "确认进行此操作"
      })
        .then(() => {
          Toast.success("成功");
        })
        .catch(() => {
          Toast.fail("已取消");
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/centerOrder/activitiesSelection.vue